import moment from 'moment'

export default {
   locale: 'my',
	formats: {
		"date-time": function(e,t) {
         return moment(new Date(e)).format('DD/MM/YYYY h:mm:ss A')
      },
      "date": function(e,t) {
         return moment(new Date(e)).format('DD/MM/YYYY')
      }
   },
   "rules": {}
}
